<template>
  <div id="addEditEmail">
    <v-form ref="emailForm">
      <v-container>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="pr-0 button-container">
            <v-btn fab absolute left :href="'#/configuration'" class="ml-3 pf-btn-fab">
              <v-icon>arrow_back</v-icon>
            </v-btn>
            <div class="text-xs-right" v-if="dirty">
              <v-btn class="pf-btn pf-btn-cancel" @click="dirty=false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container>
          <v-layout>
            <v-flex md6 sm8 xs12>
              <v-text-field spellcheck="false" class="required" :rules="[rules.required, rules.emailRules]" @input="dirty=true" v-model="newEmail.email" label="Email Address">
            </v-text-field>
           </v-flex>
          </v-layout>
      </v-container>
      <v-container mt-5 pt-5>
        <v-layout class="pr-4 pl-4"> 
          <v-flex xs12 sm12 md12 class="pr-0" v-if="dirty">
            <div class="text-xs-right">
              <v-btn class="pf-btn pf-btn-cancel" @click="dirty=false">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>
<script>
/* global session store */
import { update } from '../helpers/helpers';
import swal from 'sweetalert2';

export default {
  components: {},
  data: () => ({
    dirty: false,
    entity: 'Agency',
    newEmail: {
      email: ''
    },
    rules: {
      required: value => !!value || 'Email Address is required.',
      emailRules: (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(v) || 'Please Enter a Valid Email Address',
    },
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    }
  },
  methods: {
    async save () {
      if (this.$refs.emailForm.validate()) {
        if (this.Agency.email) {
          this.Agency.email.push(this.newEmail);
        } else {
          this.Agency.email = [this.newEmail];
        }
        let { error, data, status } = await update(this.entity, this.Agency, session.getSession().adminUser ? session.getSession().user.human.agency : 'Me');
        if (error) {
          console.log('error', error);
        } else {
          this.Agency = Object.assign({}, data);
          this.loading = false;
          swal.fire({
            type: 'success',
            title: 'Email address saved successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.$router.push({ path: '/configuration' });
            }
          });
        }
      }
    }
  }
};
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Email.vue